const bannerDefaults = {
  borderClass: '',
  btnClass: '',
  header: '',
  imgUrl: '',
  layoutStyle: true,
  location: '',
  subheader: ''
};
const { getcookie } = window;

export default {
  data: {
    banner: {},
    variations: [
      {
        borderClass: 'promo-border-pink',
        btnClass: 'border-pink text-pink',
        header: 'Let Our Team Create a <br class="hide-on-large-and-down"> Stunning Design for Your Store',
        imgUrl: 'https://www.volusion.com/assets/images/login-test-b-pop.jpg',
        layoutStyle: false,
        location: '/design-services',
        subheader: `Work with Volusion’s award-winning design <br class="hide-on-large-and-down">
        services team to create a beautiful custom website <br class="hide-on-large-and-down">
        design to take your business to the next level.`
      },
      {
        borderClass: 'promo-border-yellow',
        btnClass: 'border-yellow text-yellow',
        header: 'Drive Quality Traffic to Your <br class="hide-on-large-and-down"> Business with Expert Marketing',
        imgUrl: 'https://www.volusion.com/assets/images/login-test-c-pop.jpg',
        layoutStyle: false,
        location: '/marketing-services',
        subheader: `All the marketing expertise you need to succeed. <br class="hide-on-large-and-down">
        From SEO to PPC and everything in-between, our team of <br class="hide-on-large-and-down">
        experts has you covered. Let’s grow your business.`
      },
      {
        borderClass: 'promo-border-teal',
        btnClass: 'border-teal text-teal',
        header: 'Drive More Sales <br class="hide-on-large-and-down"> with Credit Card Processing',
        imgUrl: 'https://www.volusion.com/assets/images/login-test-a-pop.jpg',
        layoutStyle: true,
        location: '/credit-card-processing',
        subheader: `Accept payments with the industry&#39;s most <br class="ride-on-large-and-down">
        affordable rates. Our solution offers zero setup <br class="hide-on-large-and-down">
        fees, ironclad security and expert support.`
      },
      {
        borderClass: 'promo-border-blue',
        btnClass: 'border-blue text-blue',
        header: 'Sell More with a Beautiful Theme',
        imgUrl: 'https://www.volusion.com/assets/images/login-test-d-pop.jpg',
        layoutStyle: false,
        location: '/theme-services',
        subheader: `Our themes are crafted by professional designers who <br class="hide-on-large-and-down">
        specialize in ecommerce. Every theme is stunning, <br class="hide-on-large-and-down">
        responsive, fully customizable and designed to sell more.`
      }
    ]
  },
  created() {
    const version = getcookie('version') || 'v2';
    const multiplier = version.toLowerCase() === 'v2' ? 2 : 4;
    const index = Math.floor(Math.random() * multiplier);
    this.banner = Object.assign({}, bannerDefaults, this.variations[index]);
  }
};
